//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import { ALTERNATE_TOASTS } from '@legacy-components/common/toast-notifications/toastNotificationsConstants';
import {
  IToastNotification,
  ToastType,
} from '@legacy-components/common/toast-notifications/toastNotificationsModel';

const baseToastNotif = {
  options: {
    toastTemplate: ALTERNATE_TOASTS.NEW_TOAST,
  },
};

export const requestFeatureOnInstagramShopsSucceededToast: IToastNotification =
  {
    ...baseToastNotif,
    title: 'Submission Successful',
    message: `Request to feature this media on your Facebook and Instagram Shops successfully submitted to Meta. Approval by Meta can take up to three days`,
  };

export const requestFeatureOnInstagramShopsFailedToast: IToastNotification = {
  ...baseToastNotif,
  title: 'Submission Failed',
  message:
    'Submission to feature this media on your Facebook and Instagram Shops has failed. Try again or contact Bazaarvoice Support.',
  type: ToastType.ERROR,
};

export const requestInstagramShopsCatalogsFailedToast: IToastNotification = {
  ...baseToastNotif,
  title: 'Failed to retrieve Instagram Shops catalogs',
  message:
    'We were unable to retrieve your product catalogs. Please try again later or contact Bazaarvoice Support.',
  type: ToastType.ERROR,
};
